import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import { s3 } from '@shopmy/universal';
import S3Upload from '../../ImageUpload/S3Upload';
import { getSignedUrl } from '../../api/upload';
import './WheelMediaDrop.scss';

const WheelMediaDrop = ({ label, url, isVideo, onUpload, onClear, onBusyChange }) => {
  const [isUploading, setIsUploading] = useState(false);
  const [uploadPercent, setUploadPercent] = useState(0);
  const [error, setError] = useState('');
  const finish = () => { setIsUploading(false); onBusyChange(false); };
  const fail = message => { setError(message); finish(); };
  const upload = (files, rejected) => {
    if (rejected.length || files.length !== 1) return setError(`Choose one ${isVideo ? 'MP4 video under 256 MB' : 'image under 20 MB'}.`);
    setError('');
    setUploadPercent(0);
    setIsUploading(true);
    onBusyChange(true);
    new S3Upload({
      files,
      getSignedUrl: async (file, callback) => {
        try {
          const signedUrl = await getSignedUrl({ objectName: file.name, contentType: file.type });
          if (typeof signedUrl !== 'string') throw new Error('Could not start upload.');
          callback({ signedUrl });
        } catch (err) { fail(err.message); }
      },
      onError: message => fail(message),
      onProgress: percent => setUploadPercent(percent),
      onFinishS3Put: async (info, file) => {
        try { await onUpload(s3.toPublicImageUrl(info.signedUrl.split('?')[0]), file.name); }
        catch (err) { setError(err.message || 'Could not save upload.'); }
        finally { finish(); }
      }
    });
  };

  return (
    <div className='wheel-media-drop'>
      <div className='wheel-media-drop-label'>{label}</div>
      {url ? (
        <div className='wheel-media-drop-preview'>
          {isVideo ? <video src={url} muted playsInline controls preload='metadata' /> : <img src={url} alt='' />}
          <button type='button' onClick={onClear}>Remove</button>
        </div>
      ) : (
        <Dropzone onDrop={upload} multiple={false} disabled={isUploading} accept={isVideo ? 'video/mp4' : 'image/jpeg,image/png,image/webp'} maxSize={(isVideo ? 256 : 20) * 1024 * 1024}>
          {({ getRootProps, getInputProps }) => (
            <div {...getRootProps()} className='wheel-media-drop-zone'>
              <input {...getInputProps()} aria-label={label} />
              <div className='wheel-media-drop-placeholder'>{isUploading ? `Uploading ${uploadPercent}%…` : isVideo ? 'Drop an MP4 or choose a file' : 'Drop a poster or choose a file'}</div>
            </div>
          )}
        </Dropzone>
      )}
      {error && <div role='alert'>{error}</div>}
    </div>
  );
};

WheelMediaDrop.propTypes = {
  label: PropTypes.string.isRequired,
  url: PropTypes.string,
  isVideo: PropTypes.bool,
  onUpload: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  onBusyChange: PropTypes.func.isRequired
};

export default WheelMediaDrop;
